import { Routes } from '@angular/router';
import { mainViewComponent } from './main-view/main-view.component';
import { LoginViewComponent } from './login/login-view.component';
import { ForgottenPasswordViewComponent } from './login/forgotten-password-view.component';
import { ChangePasswordViewComponent } from './login/change-password-view.component';
import { blankComponent } from './components/common/layout/blank.component';
import { basicComponent } from './components/common/layout/basic.component';

import { dossiersViewComponent } from './dossiers/dossiersList/dossiers-view.component';
import { documentsComponent } from './documents/documents.component';
import { documentViewerComponent } from './documents/documentViewer/documentViewer.component';
import { userDetailComponent } from './user/userDetail/userDetail.component';
import { filePDFViewerComponent } from './documents/filePDFViewer/filePDFViewer.component';
import { tasksComponent } from './tasks/tasks.component';
import { baseTaskComponent } from './tasks/baseTask/baseTask.component';
import { AuditComponent } from './dossiers/audit/audit.component';
import { proceduresComponent } from './dossiers/procedures/procedures.component';
import { DossierInfoComponent } from './dossiers/dossierInfo/dossierInfo.component';
import { documentHistoryComponent } from './documents/documentHistory/documentHistory.component';

import { AuthGuard } from './guards/auth-guard.service';

import { calendarComponent } from './calendar/calendar.component';
import { searchComponent } from './components/search.component';
import { taskActionsProcessComponent } from './tasks/task.actions.process.component';
import { actionsComponent } from './actions/actions.component';
import { CertLoginComponent } from './login/cert-login.component';
import { tenderEventComponent } from './dossiers/tenderEvent/tenderEvent.component';
import { SsoLoginComponent } from './login/sso-login.component';
import { SsoLogoutComponent } from './login/sso-logout.component';
import { controlPanelComponent } from './admin/controlPanel/controlPanel.component';
import { logsPanelComponent } from './admin/logsPanel/logsPanel.component';
import { eventAuditPanelComponent } from './admin/eventAuditPanel/eventAuditPanel.component';
import { eventViewerPanelComponent } from './admin/eventViewerPanel/eventViewerPanel.component';
import { licensePanelComponent } from './admin/licensePanel/licensePanel.component';
import { configurationComponent } from './admin/configuration/configuration.component';
import { accountingViewComponent } from './dossiers/accounting/accounting.component';
import { userPrefsPanelComponent } from './user/userPrefs/userPrefsPanel.component';
import { performancePanelComponent } from './admin/performancePanel/performancePanel.component';
import { CanDeactivateGuard } from './guards/can-deactivate-guard.service';
import { NotLoggedInUsersGuard } from './guards/not-loggedin-guard';
import { ProfileGuard } from './guards/profile-guard.service';
import { timersPanelComponent } from './admin/timersPanel/timersPanel.component';
import { sessionsPanelComponent } from './admin/sessionsPanel/sessionsPanel.component';
import { tenderListComponent } from './dossiers/tenderView/tenderList.component';
import { rulesComponent } from './dossiers/rules/rules.component';
import { validationsPanelComponent } from './admin/validationsPanel/validationsPanel.component';
import { accesoDenegadoComponent } from './errors/accesoDenegado.component';
import { errorVisualizacionComponent } from './errors/errorVisualizacion.component';
import { procurementProjectComponent } from './dossiers/genericDossier/procurementProject.component';
import { awardsListComponent } from './dossiers/awards/awardsList.component';
import { tenderEvaluationComponent } from './dossiers/tenderView/tenderEvaluation.component';
import { GeneralHelpComponent } from './components/common/help/generalHelp.component';
import { HelpAdminComponent } from './components/common/help/helpAdmin.component';
import { ReportsComponent } from './reports/reports.component';
import { CompanyAdminComponent } from './company/companyAdmin.component';
import { CompanyListComponent } from './company/companyList.component';
import { ReportsConfComponent } from './reports/reports-conf.component';
import { dossierModelsComponent } from './dossiers/dossierModels/dossierModels.component';
import { eTenderingDefinitionComponent } from './dossiers/eTenderingDefinition/eTenderingDefinition.component';
import { awardCriteriaFormulasComponent } from './dossiers/awardCriteriaFormulas/awardCriteriaFormulas.component';
import { FEGuard } from './guards/fe-guard.service';
import { FENewGuard } from './guards/fe-new-guard.service';
import { InvoicesComponent } from './dossiers/invoices/invoices.component';
import { customFieldsPanelComponent } from './admin/customFieldsPanel/customFieldsPanel.component';
import { CommunicationEditionComponent } from './dossiers/communications/communication.edition.component';
import { ContractComponent } from './dossiers/contracts/contract.component';
import { CompanyProjectComponent } from './ril/companyproject.component';
import { OrderProjectsComponent } from './sarga/orderproject/orderprojects.component';
import { ContractModificationComponent } from './dossiers/contractModifications/contractModification.component';
import { RegisterContractModificationComponent } from './dossiers/registerContractModifications/registerContractModification.component';
import { InvoiceComponent } from './dossiers/invoices/invoice.component';
import { CustomFieldEditionComponent } from './admin/customFieldsPanel/customField.edition.component';
import { basicDocumentComponent } from './documents/basicDocument/basicDocument.component';
import { AccountingDocumentComponent } from './dossiers/accounting/accountingDocument.component';
import { ProjectQuestionsComponent } from './dossiers/questions/project-questions.component';
import { criteriaDefListPanelComponent } from './admin/criteriaListPanel/criteriaDefListPanel.component';
import { resourceFilesListPanelComponent } from './admin/resourceFilesPanel/resourceFilesPanel.component';
import { DocumentSearchComponent } from './documents/documentSearch/documentSearch.component';
import { TwoFactorAuthComponent } from './login/two-factorAuth.component';
import { AuthGuard1FA } from './guards/auth-guard-1fa.service';
import { LogoutMsgViewComponent } from './login/logout-msg.component';
import { substitutionPanelComponent } from './admin/substitutionPanel/substitutionPanel.component';
import { exportProcessPanelComponent } from './admin/exportProcessPanel/exportProcessPanel.component';
import { BudgetaryProjectsComponent } from './sarga/budgetaryProjects/budgetaryProject.component';
import { SupportSessionsComponent } from './admin/supportSessions/supportSessions.component';
import { SupportEventPanelComponent } from './cixtec/integration/bitacora/supportEventPanel.component';
import { ProjectEntityUserAuthorizationComponent } from './projectEntityUserAuthorization/projectEntityUserAuthorization.component';

import { procurementProjectAYMADComponent } from './aymad/procurementProject/procurementProjectAYMAD.component';
import { ContractAYMADComponent } from './aymad/contracts/contractAYMAD.component';
import { newDossierComponent } from './dossiers/genericDossier/newDossier.component';

import { InboxPanelComponent } from './admin/inboxsPanel/inboxPanel.component';
import { InboxEditionComponent } from './admin/inboxsPanel/inbox.edition.component';
import { UsersPanelComponent } from './admin/usersPanel/usersPanel.component';
import { FrameworkAgreementSituationAYMADComponent } from './aymad/frameworkAgreementSituation/frameworkAgreementSituationAYMAD.component';
import { OrganizationalUnitPanelComponent } from './admin/OrganizationalUnitPanel/OrganizationalUnitPanel.component';
import { demo1Component } from './demo/demo1.component';
import { ErrorMessageComponent } from './errors/error-message.component';
import { TwoFactorConfigComponent } from './login/two-factorConfig.component';
import { UnitPriceRelationDocumentComponentAYMAD } from './aymad/unitPriceRelationDocument/unitPriceRelationDocumentAYMAD.component';
import { InfrastructurePlanComponent } from './dipbad/infrastructurePlan/infrastructurePlans.component';
import { SpendingProjectsComponent } from './dipbad/spendingProject/spendingProjects.component';
import { AYMADContractModificationComponent } from './aymad/contractModifications/AYMADContractModification.component';
import { DynamicPurchasingSystemAYMADComponent } from './aymad/dynamicPurchasingSystemSituation/dynamicPurchasingSystemAYMAD.component';
import { ProtocolsPanelComponent } from './admin/protocolsPanel/protocolsPanel.component';
import { SignatureResolver } from './_core/application/signature-tool/resolver/signature-tool.resolver';
import { SignatureToolPage } from './_presentation/features/pages/signature-tool/signature-tool.page';
import { SsoSelectionComponent } from './login/sso-selection.component';
//import { ExampleComponent } from './admin/inboxsPanel/example.component';


export const ROUTES: Routes = [
  // Main redirect
  { path: '', redirectTo: 'mainView', pathMatch: 'full' },
  {
    path: '',
    component: basicComponent,
    canActivate: [AuthGuard],
    // App views
    children: [
      { path: 'newSupportEvent', component: SupportEventPanelComponent },

      {
        path: 'newSupportEvent',
        component: SupportEventPanelComponent,
        loadChildren: () => import('./cixtec/integration/bitacora/supportEventPanelPanel.module').then(m => m.SupportEventPanelModule)
      },

      {
        path: 'projectEntityUserAuthorization/:id/:authorizationType',
        component: ProjectEntityUserAuthorizationComponent,
        loadChildren: () => import('./projectEntityUserAuthorization/projectEntityUserAuthorization.module').then(m => m.ProjectEntityUserAuthorizationModule)
      },

      { path: 'mainView', component: mainViewComponent },
      {
        path: 'dossiersView',
        component: dossiersViewComponent,
        loadChildren: () => import('./dossiers/dossiersList/dossiers-view.module').then(m => m.DossiersViewModule)
      },
      {
        path: 'dossiersView/:tipoExpediente',
        component: dossiersViewComponent,
        loadChildren: () => import('./dossiers/dossiersList/dossiers-view.module').then(m => m.DossiersViewModule)
      },
      // {
      //   path: 'dossiersView/EXP',
      //   component: dossiersViewComponent,
      //   loadChildren: () => import('./dossiers/dossiersList/dossiers-view.module').then(m => m.DossiersViewModule)
      // },
      // {
      //   path: 'dossiersView/CONTRACTS',
      //   component: dossiersViewComponent,
      //   loadChildren: () => import('./dossiers/dossiersList/dossiers-view.module').then(m => m.DossiersViewModule)
      // },
      // {
      //   path: 'dossiersView/SARGA_EPTE_PRESUP',
      //   component: dossiersViewComponent,
      //   loadChildren: () => import('./dossiers/dossiersList/dossiers-view.module').then(m => m.DossiersViewModule)
      // },
      // {
      //   path: 'dossiersView/SARGA_EXPTE_ENCARGOS',
      //   component: dossiersViewComponent,
      //   loadChildren: () => import('./dossiers/dossiersList/dossiers-view.module').then(m => m.DossiersViewModule)
      // },
      {
        path: 'dossierInfo/:id',
        component: DossierInfoComponent,
        loadChildren: () => import('./dossiers/dossierInfo/dossierInfo.module').then(m => m.DossierInfoModule)
      },

      {
        path: 'dossierCreation/:id',
        component: procurementProjectComponent,
        loadChildren: () => import('./dossiers/genericDossier/genericDossier.module').then(m => m.GenericDossierModule),
        canActivate: [FEGuard],
        //data: { roles: '1,50' },
        // Se tiene que validar en el profileguard con la propiedad FraSelExpediente.habilitarBotonPreparar
        // Afecta a preparar y crear expediente desde modelo
        canDeactivate: [CanDeactivateGuard]
      },

      {
        path: 'dossierCreation',
        component: newDossierComponent,
        loadChildren: () => import('./dossiers/genericDossier/genericDossier.module').then(m => m.GenericDossierModule),
        canActivate: [FENewGuard],
        data: { roles: '1,5,50' },
        canDeactivate: [CanDeactivateGuard]
      },

      {
        path: 'procurementProject',
        component: procurementProjectComponent,
        loadChildren: () => import('./dossiers/genericDossier/genericDossier.module').then(m => m.GenericDossierModule),
        canActivate: [FEGuard],
        data: { roles: '1,5,50' },
        // Se tiene que validar en el profileguard con la propiedad FraSelExpediente.habilitarBotonPreparar
        // Afecta a preparar y crear expediente desde modelo
        canDeactivate: [CanDeactivateGuard]
      },

      {
        path: 'procurementProject/:id',
        component: procurementProjectComponent,
        loadChildren: () => import('./dossiers/genericDossier/genericDossier.module').then(m => m.GenericDossierModule),
        //canActivate: [FEGuard],
        //data: { roles: '1,5,50' },
        // Se tiene que validar en el profileguard con la propiedad FraSelExpediente.habilitarBotonPreparar
        // Afecta a preparar y crear expediente desde modelo
        canDeactivate: [CanDeactivateGuard]
      },


      {
        // Componente de Ayuntamiento de Madrid
        path: 'procurementProjectAYMAD',
        component: procurementProjectAYMADComponent,
        loadChildren: () => import('./aymad/procurementProject/procurementProjectAYMAD.module').then(m => m.ProcurementProjectAYMADModule),
        canActivate: [FEGuard],
        data: { roles: '1,50' },
        // Se tiene que validar en el profileguard con la propiedad FraSelExpediente.habilitarBotonPreparar
        // Afecta a preparar y crear expediente desde modelo
        canDeactivate: [CanDeactivateGuard]
      },
      {
        // Componente de Ayuntamiento de Madrid
        path: 'procurementProjectAYMAD/:id',
        component: procurementProjectAYMADComponent,
        loadChildren: () => import('./aymad/procurementProject/procurementProjectAYMAD.module').then(m => m.ProcurementProjectAYMADModule),
        // canActivate: [],
        // data: { roles: '1,50' },
        // Se tiene que validar en el profileguard con la propiedad FraSelExpediente.habilitarBotonPreparar
        // Afecta a preparar y crear expediente desde modelo
        canDeactivate: [CanDeactivateGuard]
      },

      // ******************** Componente Situacion Acuerdos Marco y Basados Ayuntamiento de Madrid
      {
        // Componente de Ayuntamiento de Madrid
        path: 'frameworkAgreementSituationAYMAD',
        component: FrameworkAgreementSituationAYMADComponent,
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./aymad/frameworkAgreementSituation/frameworkAgreementSituationAYMAD.module').then(m => m.FrameworkAgreementSituationAYMAD)
      },
      {
        // Componente de Ayuntamiento de Madrid
        path: 'frameworkAgreementSituationAYMAD/:id',
        component: FrameworkAgreementSituationAYMADComponent,
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./aymad/frameworkAgreementSituation/frameworkAgreementSituationAYMAD.module').then(m => m.FrameworkAgreementSituationAYMAD)
      },
      {
        // Componente de Ayuntamiento de Madrid
        path: 'frameworkAgreementSituationAYMAD/:id/:mode',
        component: FrameworkAgreementSituationAYMADComponent,
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./aymad/frameworkAgreementSituation/frameworkAgreementSituationAYMAD.module').then(m => m.FrameworkAgreementSituationAYMAD)
      },
      {
        // Componente de Ayuntamiento de Madrid. Usa el mismo modulo que la situacion de AM
        path: 'dynamicPurchasingSystemAYMAD',
        component: DynamicPurchasingSystemAYMADComponent,
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./aymad/frameworkAgreementSituation/frameworkAgreementSituationAYMAD.module').then(m => m.FrameworkAgreementSituationAYMAD)
      },
      {
        // Componente de Ayuntamiento de Madrid. Usa el mismo modulo que la situacion de AM
        path: 'dynamicPurchasingSystemAYMAD/:id',
        component: DynamicPurchasingSystemAYMADComponent,
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./aymad/frameworkAgreementSituation/frameworkAgreementSituationAYMAD.module').then(m => m.FrameworkAgreementSituationAYMAD)
      },
      {
        // Componente de Ayuntamiento de Madrid. Usa el mismo modulo que la situacion de AM
        path: 'dynamicPurchasingSystemAYMAD/:id/:mode',
        component: DynamicPurchasingSystemAYMADComponent,
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./aymad/frameworkAgreementSituation/frameworkAgreementSituationAYMAD.module').then(m => m.FrameworkAgreementSituationAYMAD)
      },
      {
        path: 'unitPriceRelationDocumentsAYMAD/:id',
        component: UnitPriceRelationDocumentComponentAYMAD,
        loadChildren: () => import('./aymad/unitPriceRelationDocument/unitPriceRelationDocumentAYMAD.module').then(m => m.UnitPriceRelationDocumentAYMAD)
      },
      // ******************** Componente Situacion Acuerdos Marco y Basados Ayuntamiento de Madrid
      {
        path: 'SpendingProject',
        component: SpendingProjectsComponent,
        loadChildren: () => import('./dipbad/spendingProject/spendingProjects.module').then(m => m.SpendingProjectsModule)
      },
      {
        path: 'SpendingProject/:id',
        component: SpendingProjectsComponent,
        loadChildren: () => import('./dipbad/spendingProject/spendingProjects.module').then(m => m.SpendingProjectsModule)
      },
      {
        path: 'orderproject',
        component: OrderProjectsComponent,
        loadChildren: () => import('./sarga/orderproject/orderprojects.module').then(m => m.OrderProjectsModule)
      },
      {
        path: 'orderproject/:id',
        component: OrderProjectsComponent,
        loadChildren: () => import('./sarga/orderproject/orderprojects.module').then(m => m.OrderProjectsModule)
      },
      {
        path: 'budgetaryProject',
        component: BudgetaryProjectsComponent,
        loadChildren: () => import('./sarga/budgetaryProjects/budgetaryProject.module').then(m => m.BudgetaryProjectsModule)
      },
      {
        path: 'budgetaryProject/:id',
        component: BudgetaryProjectsComponent,
        loadChildren: () => import('./sarga/budgetaryProjects/budgetaryProject.module').then(m => m.BudgetaryProjectsModule)
      },
      {
        path: 'contracts',
        component: ContractComponent,
        loadChildren: () => import('./dossiers/contracts/contracts.module').then(m => m.ContractsModule)
      },
      {
        path: 'companyProjects',
        component: CompanyProjectComponent,
        loadChildren: () => import('./ril/companyproject.module').then(m => m.CompanyProjectModule)
      },
      {
        // Componente de Ayuntamiento de Madrid
        path: 'contractsaymad',
        component: ContractAYMADComponent,
        loadChildren: () => import('./dossiers/contracts/contracts.module').then(m => m.ContractsModule)
        //loadChildren: () => import('./aymad/contracts/contractsAYMAD.module').then(m => m.ContractsAYMADModule),
      },
      {
        // Componente de Ayuntamiento de Madrid
        path: 'contractsaymad/:id',
        component: ContractAYMADComponent,
        loadChildren: () => import('./dossiers/contracts/contracts.module').then(m => m.ContractsModule)
        //loadChildren: () => import('./aymad/contracts/contractsAYMAD.module').then(m => m.ContractsAYMADModule),
      },
      {
        path: 'contractModifications/:id',
        component: ContractModificationComponent,
        loadChildren: () => import('./dossiers/contractModifications/contractModification.module').then(m => m.ContractModificationModule)
      },
      {
        path: 'aymadcontractModifications/:id',
        component: AYMADContractModificationComponent,
        loadChildren: () => import('./dossiers/contractModifications/contractModification.module').then(m => m.ContractModificationModule)
      },
      {
        path: 'registerContractModifications/:id',
        component: RegisterContractModificationComponent,
        loadChildren: () => import('./dossiers/contractModifications/contractModification.module').then(m => m.ContractModificationModule)
      },

      {
        path: 'documents/:id',
        component: documentsComponent,
        loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsModule)
      },
      {
        path: 'documents',
        component: documentsComponent,
        loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsModule)
      },
      { path: 'basicDocument', component: basicDocumentComponent },
      {
        path: 'documentViewer/:id',
        component: documentViewerComponent,
        loadChildren: () => import('./documents/documentViewer/documentViewer.module').then(m => m.DocumentViewerModule)
      },
      {
        path: 'documentViewer/:id/:version',
        component: documentViewerComponent,
        loadChildren: () => import('./documents/documentViewer/documentViewer.module').then(m => m.DocumentViewerModule)
      },
      {
        path: 'filePDFViewer/:id',
        component: filePDFViewerComponent,
        loadChildren: () => import('./documents/filePDFViewer/filePDFViewer.module').then(m => m.FilePDFViewerModule)
      },
      {
        path: 'userDetail/:id',
        component: userDetailComponent,
        loadChildren: () => import('./user/userDetail/userDetail.module').then(m => m.UserDetailModule)
      },
      {
        path: 'userPrefs',
        component: userPrefsPanelComponent,
        loadChildren: () => import('./user/userPrefs/userPrefsPanel.module').then(m => m.UserPrefsPanelModule)
      },
      { path: 'tasks', component: tasksComponent },
      {
        path: 'task/:id',
        component: baseTaskComponent,
        canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'audit/:id',
        component: AuditComponent,
        loadChildren: () => import('./dossiers/audit/audit.module').then(m => m.AuditModule)
      },
      {
        path: 'procedures/:id',
        component: proceduresComponent,
        loadChildren: () => import('./dossiers/procedures/procedures.module').then(m => m.ProceduresModule)
      },
      {
        path: 'calendar',
        component: calendarComponent,
        loadChildren: () => import('./calendar/calendar.module').then(m => m.CalendModule)
      },
      {
        path: 'calendarDossier/:id',
        component: calendarComponent,
        loadChildren: () => import('./calendar/calendar.module').then(m => m.CalendModule)
      },
      {
        path: 'documentHistory',
        component: documentHistoryComponent,
        loadChildren: () => import('./documents/documentHistory/documentHistory.module').then(m => m.DocumentHistoryModule)
      },
      {
        path: 'documentHistory/:id',
        component: documentHistoryComponent,
        loadChildren: () => import('./documents/documentHistory/documentHistory.module').then(m => m.DocumentHistoryModule)
      },
      {
        path: 'demo1',
        component: demo1Component,
        loadChildren: () => import('./demo/demo1.module').then(m => m.demo1Module)
      },
      {
        path: 'search',
        component: searchComponent,
        loadChildren: () => import('./components/search.module').then(m => m.searchModule)
      },
      {
        path: 'taskActionsProcess',
        component: taskActionsProcessComponent,
        loadChildren: () => import('./tasks/task.actions.process.module').then(m => m.TaskActionsProcessModule)
      },
      {
        path: 'actions',
        component: actionsComponent,
        loadChildren: () => import('./actions/actions.module').then(m => m.ActionsModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'actions/:actionClasification',
        component: actionsComponent,
        loadChildren: () => import('./actions/actions.module').then(m => m.ActionsModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'companyList',
        component: CompanyListComponent,
        loadChildren: () => import('./company/company.module').then(m => m.CompanyModule),
        canActivate: [ProfileGuard]
      },
      {
        path: 'companyAdmin',
        component: CompanyAdminComponent,
        loadChildren: () => import('./company/company.module').then(m => m.CompanyModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'tenderEvent/:id',
        component: tenderEventComponent,
        loadChildren: () => import('./dossiers/tenderEvent/tenderEvent.module').then(m => m.TenderEventModule)
      },
      {
        path: 'tenderDefinition/:id',
        component: eTenderingDefinitionComponent,
        loadChildren: () => import('./dossiers/eTenderingDefinition/eTenderingDefinition.module').then(m => m.ETenderingDefinitionModule)
      },
      {
        path: 'formulas',
        component: awardCriteriaFormulasComponent,
        loadChildren: () => import('./dossiers/awardCriteriaFormulas/awardCriteriaFormulas.module').then(m => m.awardCriteriaFormulasModule),
        canActivate: [ProfileGuard]
        //data: { roles: '0,50' }
      },
      {
        path: 'tenders/:id',
        component: tenderListComponent,
        loadChildren: () => import('./dossiers/tenderView/tenderView.module').then(m => m.TenderViewModule)
      },
      {
        path: 'tendersEvaluation/:id',
        component: tenderEvaluationComponent,
        loadChildren: () => import('./dossiers/tenderView/tenderView.module').then(m => m.TenderViewModule)
      },
      {
        path: 'awards/:id',
        component: awardsListComponent,
        loadChildren: () => import('./dossiers/awards/awards.module').then(m => m.AwardModule)
      },
      {
        path: 'controlPanel',
        component: controlPanelComponent,
        loadChildren: () => import('./admin/controlPanel/controlPanel.module').then(m => m.ControlPanelModule),
        canActivate: [ProfileGuard]
      },
      {
        path: 'logs',
        component: logsPanelComponent,
        loadChildren: () => import('./admin/logsPanel/logsPanel.module').then(m => m.LogsPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'substitutions',
        component: substitutionPanelComponent,
        loadChildren: () => import('./admin/substitutionPanel/substitutionPanel.module').then(m => m.SubstitutionPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {// listado
        path: 'customFields',
        component: customFieldsPanelComponent,
        loadChildren: () => import('./admin/customFieldsPanel/customFieldsPanel.module').then(m => m.CustomFieldsPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {// editor
        path: 'customField/:id',
        component: CustomFieldEditionComponent,
        loadChildren: () => import('./admin/customFieldsPanel/customFieldsPanel.module').then(m => m.CustomFieldsPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {// listado
        path: 'inbox',
        component: InboxPanelComponent,
        loadChildren: () => import('./admin/inboxsPanel/inboxsPanel.module').then(m => m.InboxPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {// editor
        path: 'inbox/:id',
        component: InboxEditionComponent,
        loadChildren: () => import('./admin/inboxsPanel/inboxsPanel.module').then(m => m.InboxPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },/*
      {// listado
        path: 'example',
        component: ExampleComponent,
        loadChildren: () => import('./admin/usersPanel/usersPanel.module').then(m => m.UsersPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },*/
      {// listado
        path: 'users',
        component: UsersPanelComponent,
        loadChildren: () => import('./admin/usersPanel/usersPanel.module').then(m => m.UsersPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {// listado
        path: 'protocols',
        component: ProtocolsPanelComponent,
        loadChildren: () => import('./admin/protocolsPanel/protocolsPanel.module').then(m => m.ProtocolsPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {// listado
        path: 'organizationalunits',
        component: OrganizationalUnitPanelComponent,
        loadChildren: () => import('./admin/OrganizationalUnitPanel/OrganizationalUnitPanel.module')
          .then(m => m.OrganizationalUnitPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'criteriaDefList',
        component: criteriaDefListPanelComponent,
        loadChildren: () => import('./admin/criteriaListPanel/criteriaDefListPanel.module').then(m => m.CriteriaDefPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'resourceFiles',
        component: resourceFilesListPanelComponent,
        loadChildren: () => import('./admin/resourceFilesPanel/resourceFilesPanel.module').then(m => m.ResourceFilesPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },

      {
        path: 'dossierModels',
        component: dossierModelsComponent,
        loadChildren: () => import('./dossiers/dossierModels/dossierModels.module').then(m => m.DossierModelsModule)
      },
      {
        path: 'sessions',
        component: sessionsPanelComponent,
        loadChildren: () => import('./admin/sessionsPanel/sessionsPanel.module').then(m => m.SessionsPanelModule),
        canActivate: [ProfileGuard]
        //data: { roles: '0,50' }
      },
      {
        path: 'AudMessage',
        component: eventViewerPanelComponent,
        loadChildren: () => import('./admin/eventViewerPanel/eventViewerPanel.module').then(m => m.EventViewerPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'InfrastructurePlan',
        component: InfrastructurePlanComponent,
        loadChildren: () => import('./dipbad/infrastructurePlan/infrastructurePlans.module').then(m => m.InfrastructurePlanModel),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'InfrastructurePlan/:id',
        component: InfrastructurePlanComponent,
        loadChildren: () => import('./dipbad/infrastructurePlan/infrastructurePlans.module').then(m => m.InfrastructurePlanModel),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'timers',
        component: timersPanelComponent,
        loadChildren: () => import('./admin/timersPanel/timersPanel.module').then(m => m.TimersPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'eventAudit',
        component: eventAuditPanelComponent,
        loadChildren: () => import('./admin/eventAuditPanel/eventAuditPanel.module').then(m => m.EventAuditPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'monitorization',
        component: performancePanelComponent,
        loadChildren: () => import('./admin/performancePanel/performancePanel.module').then(m => m.PerformancePanelModule),
        canActivate: [ProfileGuard]
        //data: { roles: '0,50' }
      },
      {
        path: 'license',
        component: licensePanelComponent,
        loadChildren: () => import('./admin/licensePanel/licensePanel.module').then(m => m.LicensePanelModule),
        canActivate: [ProfileGuard]
        //data: { roles: '0,50' }
      },
      {
        path: 'configuration',
        component: configurationComponent,
        loadChildren: () => import('./admin/configuration/configuration.module').then(m => m.ConfigurationModule)
      },
      {
        path: 'validations',
        component: validationsPanelComponent,
        loadChildren: () => import('./admin/validationsPanel/validationsPanel.module').then(m => m.ValidationsPanelModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'supportSessions',
        component: SupportSessionsComponent,
        loadChildren: () => import('./admin/supportSessions/supportSessions.module').then(m => m.SupportSessionsModule),
        canActivate: [ProfileGuard]
        // data: { roles: '0,50' }
      },
      {
        path: 'accounting/:id',
        component: accountingViewComponent,
        loadChildren: () => import('./dossiers/accounting/accounting.module').then(m => m.AccountingViewModule)
      },
      {
        path: 'rules/:id',
        component: rulesComponent,
        loadChildren: () => import('.//dossiers/rules/rules.module').then(m => m.RulesModule)
      },
      {
        path: 'contracts/:id',
        component: ContractComponent,
        loadChildren: () => import('./dossiers/contracts/contracts.module').then(m => m.ContractsModule)
      },
      {
        path: 'companyProjects/:id',
        component: CompanyProjectComponent,
        loadChildren: () => import('./ril/companyproject.module').then(m => m.CompanyProjectModule)
      },
      {
        path: 'generalHelp',
        component: GeneralHelpComponent,
        loadChildren: () => import('./components/common/help/help.module').then(m => m.HelpModule),
      },
      {
        path: 'helpAdmin',
        component: HelpAdminComponent,
        loadChildren: () => import('./components/common/help/help.module').then(m => m.HelpModule),
        canActivate: [ProfileGuard],
        data: { roles: '0,50' }
      },
      {
        path: 'reports',
        component: ReportsComponent,
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'reports-conf',
        component: ReportsConfComponent,
        loadChildren: () => import('./reports/reports-conf.module').then(m => m.ReportsConfModule)
      },
      {
        path: 'invoicesView',
        component: InvoicesComponent,
        loadChildren: () => import('./dossiers/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      {
        path: 'invoices/:id',
        component: InvoiceComponent,
        loadChildren: () => import('./dossiers/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      {
        path: 'accountingDocuments/:id',
        component: AccountingDocumentComponent,
        loadChildren: () => import('./dossiers/accounting/accounting.module').then(m => m.AccountingViewModule),
      },
      {
        path: 'accesoDenegado',
        component: accesoDenegadoComponent,
        loadChildren: () => import('./errors/error-message.module').then(m => m.ErrorMessageModule)
      },
      {
        path: 'errorVisualizacion',
        component: errorVisualizacionComponent,
        loadChildren: () => import('./errors/error-message.module').then(m => m.ErrorMessageModule)
      },
      {
        path: 'communications/:id',
        component: CommunicationEditionComponent,
        loadChildren: () => import('./dossiers/communications/communications.module').then(m => m.CommunicationsModule),
        canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'communications/:project/:channel/:activity',
        component: CommunicationEditionComponent,
        loadChildren: () => import('./dossiers/communications/communications.module').then(m => m.CommunicationsModule),
        canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'dossier/:id/questions',
        component: ProjectQuestionsComponent,
        loadChildren: () => import('./dossiers/questions/project-questions.module').then(m => m.ProjectQuestionsModule),
      },
      {
        path: 'searchDocuments',
        component: DocumentSearchComponent,
        loadChildren: () => import('./documents/documentSearch/documentSearch.module').then(m => m.DocumentSearchModule)
      },
      {
        path: 'exportProcesses',
        component: exportProcessPanelComponent,
        loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsModule),
        canActivate: [ProfileGuard]
      },
      //TODO: When Merge, delete this -signatureTool-
      {
        path: 'signatureTool',
        resolve: { signature: SignatureResolver },
        component: SignatureToolPage,
        loadChildren: () => import('./_presentation/features/pages/signature-tool/signature-tool.module').then(m => m.SignatureToolModule)
      }
    ]
  },
  {
    path: 'forgotten-password',
    component: ForgottenPasswordViewComponent,
    loadChildren: () => import('./login/forgotten-password-view.module').then(m => m.ForgottenPasswordViewModule)
  },
  {
    canActivate: [AuthGuard1FA],
    path: '2FA',
    component: TwoFactorAuthComponent,
    loadChildren: () => import('./login/login-view.module').then(m => m.LoginViewModule)
  },
  {
    canActivate: [AuthGuard1FA],
    path: '2FAConfig',
    component: TwoFactorConfigComponent,
    canDeactivate: [CanDeactivateGuard],
    loadChildren: () => import('./login/login-view.module').then(m => m.LoginViewModule)
  },
  {
    path: 'change-password',
    component: ChangePasswordViewComponent,
    loadChildren: () => import('./login/change-password-view.module').then(m => m.ChangePasswordViewModule)
  },
  {
    path: 'sso-selection', component: SsoSelectionComponent,
    loadChildren: () => import('./login/login-view.module').then(m => m.LoginViewModule)
  },
  {
    path: 'sso-logout', component: SsoLogoutComponent,
    loadChildren: () => import('./login/login-view.module').then(m => m.LoginViewModule)
  },
  {
    path: 'logout-msg', component: LogoutMsgViewComponent,
    loadChildren: () => import('./login/login-view.module').then(m => m.LoginViewModule)
  },
  {
    path: 'error', component: ErrorMessageComponent,
    loadChildren: () => import('./errors/error-message.module').then(m => m.ErrorMessageModule)
  },
  {
    path: '',
    component: blankComponent,
    canActivate: [NotLoggedInUsersGuard],
    children: [
      {
        path: 'login', component: LoginViewComponent,
        loadChildren: () => import('./login/login-view.module').then(m => m.LoginViewModule)
      },
      {
        path: 'cert-login', component: CertLoginComponent,
        loadChildren: () => import('./login/login-view.module').then(m => m.LoginViewModule)
      },
      {
        path: 'sso-login', component: SsoLoginComponent,
        loadChildren: () => import('./login/login-view.module').then(m => m.LoginViewModule)
      }
    ]
  },
  // Rutas de adaptacion
  {
    path: 'dossiersView/SARGA_EPTE_PRESUP',
    component: dossiersViewComponent,
    loadChildren: () => import('./dossiers/dossiersList/dossiers-view.module').then(m => m.DossiersViewModule)
  },
  {
    path: 'dossiersView/SARGA_EXPTE_ENCARGOS',
    component: dossiersViewComponent,
    loadChildren: () => import('./dossiers/dossiersList/dossiers-view.module').then(m => m.DossiersViewModule)
  },
  {
    path: 'dossiersView/INFRASTRUCTUREPLAN',
    component: dossiersViewComponent,
    loadChildren: () => import('./dossiers/dossiersList/dossiers-view.module').then(m => m.DossiersViewModule)
  },
  {
    path: 'dossiersView/SPENDINGPROJECTS',
    component: dossiersViewComponent,
    loadChildren: () => import('./dossiers/dossiersList/dossiers-view.module').then(m => m.DossiersViewModule)
  },

  // Handle all other routes
  { path: '**', component: mainViewComponent },


];
